/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2025, Zumper
 */

export function getEnumType<Enum extends object>(enoom: Enum): string | undefined {
  if ('__ENUM_NAME' in enoom && typeof enoom.__ENUM_NAME === 'string') {
    return enoom.__ENUM_NAME
  }
}
